/** Test handles for GuestBanner. The dismiss control is icon-only, so it needs a stable testID. */
export const GUEST_BANNER_TEST_IDS = {
  CONTAINER: 'guest-banner',
  SIGN_UP: 'guest-banner-sign-up',
  DISMISS: 'guest-banner-dismiss',
} as const;

/** Shared `action` label for every GuestBanner analytics event (shown/accepted). */
export const GUEST_BANNER_ACTION = 'banner';

/**
 * Honest carrot copy. Conversion floors coins to 1000 (specs/authentication), so the 1000-coin
 * promise is real and already built. We never say "keep the coins you won" (no pending-coins infra).
 */
export const GUEST_BANNER_COPY = 'Sign up for 1000 coins, add friends, and the full experience.';
